<div class="container">
  <ng-container *ngFor="let channel of channels; let $index = index">
    <div
      class="channel-card htv-selectable htv-autofocus {{ $index === 0 ? 'htv-focus' : '' }}"
      (focusin)="focusChannel(channel)"
      (click)="openChannel()"
      tabindex="-1">
      <div class="channel-card__inner">
        <ng-container *ngIf="channel.logoUrl">
          <img class="channel-card__logo" [src]="channel.logoUrl" />
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
